import workspaceRequestTab from './workspaceRequestTab';

export default [
  workspaceRequestTab,
];
